/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 21.04.2016
 *
 */
'use strict';

//Includes
import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Button, Col, Container, Row } from 'external/react-bootstrap';
//External Plugins
import {
  AppContext,
  ContextContainer,
  DataLinkContainer,
  DataUtil,
  debounce,
  flagHOC,
  FormActions,
  ScrollableDataListRV,
  translation,
  wrapWithCommonFormContainer
} from 'plugin/liferay-widgets-react-web';
import { FliwasObjectMasterDetailList, SelectObjectErrorMessage } from 'plugin/base-portlet';
//Current Module
import FliwasOrganizationListItem from '../components/FliwasOrganizationListItem';
import FliwasOrganizationDetails from '../components/FliwasOrganizationDetails';
import { getFliwasOrganizationStore } from '../stores/StoreFactory';
import FliwasOrganizationEditForm from '../components/FliwasOrganizationEditForm';
import FliwasOrganizationNewForm from '../components/FliwasOrganizationNewForm';
import FliwasOrganizationActions from '../actions/FliwasOrganizationActions';
import { FeatureDisplayPlugin, Map, PrintPlugin } from 'plugin/map-portlet';

//Stores
const FliwasOrganizationStore = getFliwasOrganizationStore(AppContext);

//DataLinks
const FliwasOrganizationListLinkCHOC = DataLinkContainer.link(ScrollableDataListRV, [ 'list', 'activeIds' ], getFliwasOrganizationStore(AppContext));
const FliwasOrganizationDetailsHOC = flagHOC(FliwasOrganizationDetails, [ 'item' ]);
const FliwasOrganizationNewFormHoc = wrapWithCommonFormContainer(FliwasOrganizationNewForm);
const FliwasOrganizationEditFormHoc = wrapWithCommonFormContainer(FliwasOrganizationEditForm);

class FliwasOrganizationMasterDetailWidget extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      searchValue: '',
    };

    this.DATA = {
      ORGANIZATIONS: this.withCtx('_FliwasOrganizations'),
      FEREDAL_STATE_ORGANIZATIONS: this.withCtx('_FederalStateOrganizations'),
      SELECTED_ORGANIZATION: this.withCtx('_SelectedFliwasOrganization'),

      FORM_NEW_ORGANIZATION: this.withCtx('_FliwasOrganizationNew'),
      FORM_EDIT_ORGANIZATION: this.withCtx('_FliwasOrganizationEdit')
    };

    this.searchGroup = debounce(this.searchGroup, 300);
  }

  static getStores() {
    return [
      FliwasOrganizationStore
    ];
  }

  static calculateState(prevState, undefined, DATA) {
    return {
      selectedFliwasOrganization: FliwasOrganizationStore.getRemoteData(DATA.SELECTED_ORGANIZATION)
    };
  }

  componentDidMount() {
    FliwasOrganizationActions.listForFederalState(this.DATA.ORGANIZATIONS, {
      start: 0,
      end: AppContext.DEFAULT_LIST_SIZE
    });
    FliwasOrganizationActions.listFederalStates(this.DATA.FEREDAL_STATE_ORGANIZATIONS, {});
  }

  componentDidUpdate() {
  }

  selectFliwasOrganization(fliwasOrganization) {
    this.changeSelected(fliwasOrganization);
  }

  changeSelected(fliwasOrganization) {
    //Current Object
    FliwasOrganizationActions.itemByGroupId(this.DATA.SELECTED_ORGANIZATION, { id: fliwasOrganization.groupId });
  }

  moreFliwasOrganizations(query) {
    FliwasOrganizationActions.moreItems(this.DATA.ORGANIZATIONS, query);
  }

  newFliwasOrganization() {
    FormActions.startEditFormItem(this.DATA.FORM_NEW_ORGANIZATION, {
      federalState: ''
    });
  }

  editFliwasOrganization() {
    const _item = this.state.selectedFliwasOrganization;
    FormActions.startEditFormItem(this.DATA.FORM_EDIT_ORGANIZATION, _item);
  }

  onFliwasOrganizationEditFormSubmit(data) {
    const res = FliwasOrganizationActions.updateItem(data, this.DATA.FORM_EDIT_ORGANIZATION, true);
    console.info('EDIT', res);
  }

  onFliwasOrganizationNewFormSubmit(data) {
    FliwasOrganizationActions.createItem(data, this.DATA.FORM_NEW_ORGANIZATION, true);
  }

  handleChangeNewForm(formData, formValidation) {
    FormActions.changedEditFormItem(this.DATA.FORM_NEW_ORGANIZATION, {
      ...formData
    }, formValidation);
  }

  handleChangeEditForm(formData, formValidation) {
    FormActions.changedEditFormItem(this.DATA.FORM_EDIT_ORGANIZATION, {
      ...formData
    }, formValidation);
  }

  updateSearchValue(e) {
    const searchValue = e.target.value;
    this.searchGroup(searchValue);
  }

  searchGroup(searchValue) {
    FliwasOrganizationActions.search(this.DATA.ORGANIZATIONS, {
      start: 0,
      end: AppContext.DEFAULT_LIST_SIZE,
      searchValue: searchValue
    });
  }

  _refresh() {
    let _self = this;
    FliwasOrganizationActions.listForFederalState(_self.DATA.ORGANIZATIONS, {
      start: 0,
      end: AppContext.DEFAULT_LIST_SIZE
    });
    FliwasOrganizationActions.listFederalStates(_self.DATA.FEREDAL_STATE_ORGANIZATIONS, {});

    _self.changeSelected(_self.state.selectedFliwasOrganization.item);

  }

  /*eslint react/jsx-no-bind: 0*/
  render() {
    const { searchValue } = this.state;

    const
      selectedFliwasOrganizationDataItem = this.state.selectedFliwasOrganization && this.state.selectedFliwasOrganization,
      selectedFliwasOrganization = DataUtil.asItem(selectedFliwasOrganizationDataItem);

    /*eslint react/jsx-no-bind: 0*/
    return (
      <Container fluid>
        <Row>
          <FliwasObjectMasterDetailList
            searchFunc={this.updateSearchValue.bind(this)}
            createClick={this.newFliwasOrganization.bind(this)}
            refreshClick={this._refresh.bind(this)}
            searchValue={searchValue}
          >

            <FliwasOrganizationListLinkCHOC
              list={this.DATA.ORGANIZATIONS}
              size="medium"
              activeIds={this.DATA.SELECTED_ORGANIZATION}
              ListItem={FliwasOrganizationListItem}
              onClick={this.selectFliwasOrganization.bind(this)}
              onClickMore={this.moreFliwasOrganizations.bind(this)}
            />
          </FliwasObjectMasterDetailList>

          <Col lg={9} md={12} sm={12} xs={12}>
            <Row>
              <FliwasOrganizationNewFormHoc
                formId={this.DATA.FORM_NEW_ORGANIZATION}
                federalStatesDataList={this.DATA.FEREDAL_STATE_ORGANIZATIONS}
                handleBoundingBoxChange={this.handleChangeNewForm.bind(this)}
                handleGeometryChange={this.handleChangeNewForm.bind(this)}
                onFormSubmit={this.onFliwasOrganizationNewFormSubmit.bind(this)}
                context={{
                  contextId: this.props.portletId
                }}
              />

              <FliwasOrganizationEditFormHoc
                formId={this.DATA.FORM_EDIT_ORGANIZATION}
                federalStatesDataList={this.DATA.FEREDAL_STATE_ORGANIZATIONS}
                handleGeometryChange={this.handleChangeEditForm.bind(this)}
                handleBoundingBoxChange={this.handleChangeEditForm.bind(this)}
                onFormSubmit={this.onFliwasOrganizationEditFormSubmit.bind(this)}
                context={{
                  contextId: this.props.portletId
                }}
              />

              {!selectedFliwasOrganizationDataItem &&
                <Col lg={12} md={12} sm={12} xs={12}>
                  <SelectObjectErrorMessage content={translation.trans('choose-fliwas-client')}/>
                </Col>
              }

              {selectedFliwasOrganizationDataItem &&
                <Col lg={12} md={12} sm={12} xs={12}>
                  <Row className="padding-box px-0">
                    <Col lg={6} md={12} sm={12} xs={12}>
                      <Button variant="primary" title="Bearbeiten"
                              onClick={this.editFliwasOrganization.bind(this)}>Bearbeiten</Button>
                      <FliwasOrganizationDetailsHOC item={selectedFliwasOrganization}/>
                    </Col>
                    {selectedFliwasOrganization && selectedFliwasOrganization.geometry &&
                      <Col lg={6} md={12} sm={12} xs={12}>
                        <Map
                          defaultFallbackMapConfigType={'static'}
                          plugins={[ FeatureDisplayPlugin, PrintPlugin ]}
                          features={[ selectedFliwasOrganizationDataItem ]}
                        />
                      </Col>
                    }
                  </Row>
                </Col>
              }
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}

FliwasOrganizationMasterDetailWidget.propTypes = {
  portletId: PropTypes.string.isRequired,
};

export default ContextContainer.create(FliwasOrganizationMasterDetailWidget);



// WEBPACK FOOTER //
// ./js/widgets/FliwasOrganizationMasterDetailWidget.jsx